<template>
    <div class="popupContainer">
        <div class="checkinPopContainer">
            <div class="headBar">
                <van-row v-if="!isVerify">
                    <van-col span="18" class="headText">{{ $t('activity.getSMS', {
                        rewards: reward,
                        days: days
                    })
                        }}</van-col>
                </van-row>
                <van-row>
                    <van-col span="18" class="headText">{{ $t('activity.login') }} <span>{{ totalClaimedCount
                    }}</span> {{
                                $t('activity.daysRow')
                            }}</van-col>
                    <van-col span="6" class="history-col">
                        <div @click="openHistoryPopup">
                            {{ $t('common.history') }}
                            <van-icon name="play" style="padding-top: 2px;" />
                        </div>
                    </van-col>
                    <van-col span="24" class="headText">{{ $t('activity.recieved') }} <span>{{ totalClaimedAmount
                    }}</span></van-col>
                </van-row>
            </div>
            <div class="daysContainer">
                <van-row class="colDetails">
                    <van-col span="8" style="display: flex; align-items: center;justify-content: center;">
                        <div class="colorText"
                            style="background-image: linear-gradient(45deg, rgb(22 49 134), rgb(40 167 164));">
                        </div>
                        <div> {{ $t('activityStatus.completed') }}</div>
                    </van-col>
                    <van-col span="8" style="display: flex; align-items: center; justify-content: center;">
                        <div class="colorText"
                            style="background-image: linear-gradient(45deg, rgb(89 7 34 / 40%), rgb(235 1 1 / 40%));">
                        </div>
                        <div> {{ $t('common.notCompleted') }}</div>
                    </van-col>
                    <van-col span="8" style="display: flex; align-items: center; justify-content: center;">
                        <div class="colorText"
                            style="background-image: linear-gradient(45deg, rgb(24 106 48), rgb(143 217 39));">
                        </div>
                        <div> {{ $t('activity.today') }}</div>
                    </van-col>
                </van-row>
                <van-row>
                    <van-col span="6" v-for="(item, i) in configDays" :key="i" class="cardContainer">
                        <CheckinCard :amount="reward" :data="item" @getClaim="getCliam" />
                    </van-col>
                </van-row>
            </div>
        </div>

    </div>

    <LoadingScreen ref="loadingRef" />
    <StatusPopup ref="statusRef" :is-show-success="isSuccess" :content="toastContent" />
    <CheckingHistoryPopup ref="historyRef" />
</template>

<script setup lang="ts">
import { ref, defineExpose, defineEmits, PropType, computed, defineProps } from 'vue'
import StatusPopup from '@/components/common/statusPopup.vue'
import LoadingScreen from '@/components/common/loadingScreen.vue'
import { useI18n } from 'vue-i18n';
import CheckinCard from './checkinCard.vue';
import { checkinClaimRewards, checkinRewardStatus } from '@/api/activity';
import CheckingHistoryPopup from './checkingHistoryPopup.vue';
import { useUserStore } from '@/stores/user';
import CustomHeader from '../../components/common/customHeader.vue';

const props = defineProps({
    list: {
        type: Array as PropType<(any)[]>,
        default: () => []
    },
    showIcon: {
        type: Boolean
    },
    isUseFirstRecharge: {
        type: Boolean,
        default: () => false
    }
})
const userStore = useUserStore()
const emits = defineEmits(['goToVerify'])
const { t } = useI18n();
const show = ref(false)
const isSuccess = ref(false)
const statusRef = ref()
const toastContent = ref('')
const title = ref('')
const loadingRef = ref()
const configData = ref<any>({})
const reward = computed(() => configData.value?.reward)
const days = computed(() => configData.value?.days)
const configDays = ref<any[]>([])
const totalClaimedCount = ref(0)
const totalClaimedAmount = ref(0)
const historyRef = ref()
const isVerify = ref(false)
const open = (data: any, verify: boolean) => {
    getStatusRecords()
    show.value = true
    isVerify.value = verify
    configData.value = data
    title.value = `R$ ${configData.value.reward} `
}

const close = () => {
    show.value = false
    totalClaimedAmount.value = 0
    totalClaimedCount.value = 0
    configDays.value = []
    configData.value = {}
}

const openHistoryPopup = () => {
    historyRef.value.open()
}
const showError = (message: string) => {
    toastContent.value = message;
    isSuccess.value = false;
    statusRef.value.open()
}
const showSuccess = (message: string) => {
    toastContent.value = message;
    isSuccess.value = true;
    statusRef.value.open()
}
const getStatusRecords = () => {
    checkinRewardStatus().then(res => {
        loadingRef.value.close()
        configDays.value = res.data?.days || []
        totalClaimedAmount.value = res.data?.totalClaimedAmount || 0
        totalClaimedCount.value = res.data?.totalClaimedCount || 0

    }).catch(err => {
        loadingRef.value.close()
        showError(err);
    })
}
const getCliam = () => {
    let data = {
        uid: userStore.id
    }
    checkinClaimRewards(data).then(res => {
        loadingRef.value.close()
        showSuccess(res.msg)
        getStatusRecords()
    }).catch(err => {
        loadingRef.value.close()
        showError(err);
    })
}
const goToVerify = () => {
    emits('goToVerify', 1)
}
defineExpose({
    open,
    close
})
</script>
<style scoped>
.popupContainer {
    width: 100%;
    /* height: 100vh; */
    overflow: hidden;
    background-color: #101629;
    border-radius: 10px;
}

.checkinPopContainer {
    /* padding: 130px 0 25px;
    height: calc(100vh - 20px); */
    overflow-y: auto;
    box-sizing: border-box;
    scrollbar-width: none;
    -ms-overflow-style: none;
}

.checkinPopContainer::-webkit-scrollbar {
    display: none;
}


.headBar {
    background-color: #101b42;
    padding: 10px;
    border-radius: 10px;
    /* position: fixed;
    top: 50px;
    left: 0;
    right: 0;
    z-index: 1;
    border: 1px solid #713363; */
}

.headText {
    padding: 5px;
    font-size: 13px;
    font-weight: 600;
    color: #fff;
}

.headText span {
    color: #FFF000;
    padding: 0 3px;
    font-size: 13px;
}

.verifyBtn {
    display: flex;
    justify-content: right;
}

.click_btn {
    color: #fff;
    font-size: 11.5px;
    background-image: linear-gradient(270deg, #e151a4, #e66fc8);
    border-radius: 5px;
    padding: 5px 10px;
    display: flex;
    align-items: center;
    display: flex;
    text-align: center;
    justify-content: center;
    width: 40%;
    margin-right: 5px;
}

.daysContainer {
    padding: 15px 5px;
}

.colDetails {
    padding: 10px;
    background-color: #101b42;
    border: 1px solid #a47b5d;
    color: #fff;
    border-radius: 5px;
    font-size: 13px;
    margin-bottom: 5px;
}

.colorText {
    height: 8px;
    width: 8px;
    margin-right: 5px;
}

.cardContainer {
    padding: 5px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.history-col {
    font-size: 11px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: row;
    text-align: center;
    padding: 5px;
    background-color: #ffffff38;
    border-radius: 5px;
    color: #fff;
}
</style>